import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'connected-react-router';
import { OrderedMap } from 'immutable';

import SavedVehiclesComponent from 'components/account/saved-vehicles';

import Brand from 'models/brand';

import deleteVehicleCreator from 'action-creators/vehicles/delete-vehicle';
import setDefaultVehicleCreator from 'action-creators/vehicles/set-default-vehicle';
import trackEventCreator from 'action-creators/analytics/track-event';

const propTypes = {
  brand: PropTypes.instanceOf(Brand).isRequired,
  vehicles: PropTypes.instanceOf(OrderedMap).isRequired,
  addNewVehicle: PropTypes.func.isRequired,
  editVehicle: PropTypes.func.isRequired,
  deleteVehicle: PropTypes.func.isRequired,
  defaultVehicleId: PropTypes.number,
  setDefaultVehicle: PropTypes.func.isRequired,
  selectedVehicleId: PropTypes.string,
  app: PropTypes.string.isRequired,
  trackEvent: PropTypes.func.isRequired,
};

const defaultProps = {
  selectedVehicleId: null,
  defaultVehicleId: null,
  setDefaultVehicle: null,
};

const SavedVehiclesWrapper = ({
  brand,
  vehicles,
  addNewVehicle,
  editVehicle,
  deleteVehicle,
  defaultVehicleId,
  setDefaultVehicle,
  selectedVehicleId,
  app,
  trackEvent,
}) => (
  <SavedVehiclesComponent
    brand={brand}
    vehicles={vehicles}
    addNewVehicle={addNewVehicle}
    editVehicle={editVehicle}
    deleteVehicle={deleteVehicle}
    defaultVehicleId={defaultVehicleId}
    setDefaultVehicle={setDefaultVehicle}
    selectedVehicleId={selectedVehicleId}
    app={app}
    trackEvent={trackEvent}
  />
);

SavedVehiclesWrapper.propTypes = propTypes;
SavedVehiclesWrapper.defaultProps = defaultProps;

const mapStateToProps = (state) => {
  const {
    brand,
  } = state.brand;
  const { name: app } = state.app;
  const {
    vehicles,
    selectedVehicleId,
    defaultVehicleId,
  } = state.account;

  return {
    brand,
    vehicles,
    selectedVehicleId,
    defaultVehicleId,
    app,
  };
};

const editVehicle = vehicle => push(vehicle.editURL);
const addNewVehicle = () => push('/account/vehicles/add/');

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    addNewVehicle,
    editVehicle,
    deleteVehicle: deleteVehicleCreator,
    setDefaultVehicle: setDefaultVehicleCreator,
    trackEvent: trackEventCreator,
  }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(SavedVehiclesWrapper);
